import React from 'react';
import { Helmet } from "react-helmet";
import { SiteContext } from '../context';

import { replaceWpUrl, wpUrl } from '../utils/url';


const RawLayout = ({
  currentLanguage,
  children,
  translations,
}) => {

  const xDefaultFallback = ['EN','FR','ES','BE_FR','BE_NL'];
  const availableLanguages = [
    { ...currentLanguage, link: wpUrl + currentLanguage.uri },
    ...(translations ?? [])
  ]
  .sort((a, b) => xDefaultFallback.indexOf(a.language.slug) - xDefaultFallback.indexOf(b.language.slug))
  .filter(({ language }) => Boolean(language));

  return (
    <SiteContext.Provider>
      <Helmet>
        <link rel="canonical" href={replaceWpUrl(wpUrl + currentLanguage.uri)} />
        <link rel="alternate" hreflang="x-default" href={replaceWpUrl(availableLanguages.at(0)?.link)} />
        {availableLanguages?.map(({ link, language: { locale } }) => (
          <link key={locale} rel="alternate" hreflang={locale.toLowerCase().replace('_', '-')} href={replaceWpUrl(link)} />
        ))}
      </Helmet>
      {children}
    </SiteContext.Provider>
  );
};

export default RawLayout;
